import {
  AppShell,
  Burger,
} from '@mantine/core';
import * as React from 'react';

import { Nav } from '@/components/Navigation/Navbar';
import { useState } from 'react';
import storage from '@/utils/storage';

type MainLayoutProps = {
  children: React.ReactNode;
};

export const MainLayout = ({ children }: MainLayoutProps) => {
  const [mobileOpened, setMobileOpened] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(storage.getSidebarOpenState() ?? true);

  const toggleSidebar = () => {
    storage.setSidebarOpenState(!sidebarOpen);
    setSidebarOpen((o) => !o);
  };

  return (
    <AppShell
      navbar={{
        width: sidebarOpen ? 320 : 80,
        breakpoint: 'md',
        collapsed: { mobile: !mobileOpened },
      }}
      header={{ height: { base: 50, sm: 70, md: 0 } }}
    >
      <AppShell.Header>
        <div style={{ display: 'flex', alignItems: 'center', height: '100%', paddingInline: 'var(--mantine-spacing-md)' }}>
          <Burger
            hiddenFrom="md"
            opened={mobileOpened}
            onClick={() => setMobileOpened((o) => !o)}
            size="sm"
          />
        </div>
      </AppShell.Header>
      <Nav open={sidebarOpen} onToggleOpen={toggleSidebar} />
      <AppShell.Main m={16}>{children}</AppShell.Main>
    </AppShell>
  );
};
